import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const STATIC_WEBSITE_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.staticWebsite.buyBox.bulletPoint1' },
        { title: 'productPage.staticWebsite.buyBox.bulletPoint2' },
        { title: 'productPage.staticWebsite.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.staticWebsite.buyBox.productName',
      interactService: {
        service: 'static_website'
      },
      note: 'productPage.staticWebsite.buyBox.smallCopy'
    }],
    headerPicture: {
      src: '/s2/raster/website-builder-collage-templates.png ',
      alt: 'productPage.staticWebsite.heroPicture.altText'
    },
    headline: 'productPage.staticWebsite.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.staticWebsite.page.subheader'
  },
  showCase: {
    title: 'productPage.staticWebsite.showCase.title',
    stylesItem: {
      variantItem: 'outlined'
    },
    items: [
      {
        image: '/s2/raster/template-store-tile.png',
        alt: 'productPage.staticWebsite.showCase.alt'
      },
      {
        image: '/s2/raster/template-realestate-tile.png',
        alt: 'productPage.staticWebsite.showCase.alt'
      },
      {
        image: '/s2/raster/template-consulting-tile.png',
        alt: 'productPage.staticWebsite.showCase.alt'
      },
      {
        image: '/s2/raster/template-contractors-tile.png',
        alt: 'productPage.staticWebsite.showCase.alt'
      },
      {
        image: '/s2/raster/template-cleaning-tile.png',
        alt: 'productPage.staticWebsite.showCase.alt'
      }
    ]
  },
  benefit: {
    title: 'productPage.staticWebsite.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/languagerounded.svg',
        title: 'productPage.staticWebsite.valueProp.propTitle1',
        description: 'productPage.staticWebsite.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/trendinguprounded.svg ',
        title: 'productPage.staticWebsite.valueProp.propTitle2',
        description: 'productPage.staticWebsite.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/eventnoterounded.svg',
        title: 'productPage.staticWebsite.valueProp.propTitle3',
        description: 'productPage.staticWebsite.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/paidrounded.svg',
        title: 'productPage.staticWebsite.valueProp.propTitle4',
        description: 'productPage.staticWebsite.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/mobilefriendlyrounded.svg',
        title: 'productPage.staticWebsite.valueProp.propTitle5',
        description: 'productPage.staticWebsite.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/supportrounded.svg',
        title: 'productPage.staticWebsite.valueProp.propTitle6',
        description: 'productPage.staticWebsite.valueProp.shortCopy6'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/trendinguprounded.svg',
    title: 'productPage.staticWebsite.topFeature.title',
    subheader: 'productPage.staticWebsite.topFeature.subheader',
    image: '/s2/raster/florist-phone-outside.png',
    alt: 'productPage.staticWebsite.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.staticWebsite.howItWorks.title',
    items: [
      {
        description: 'productPage.staticWebsite.howItWorks.step1'
      },
      {
        description: 'productPage.staticWebsite.howItWorks.step2'
      },
      {
        description: 'productPage.staticWebsite.howItWorks.step3'
      },
      {
        description: 'productPage.staticWebsite.howItWorks.step4'
      },
      {
        description: 'productPage.staticWebsite.howItWorks.step5'
      }
    ],
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
    video: 'h59b0zg2sy'
  },
  socialProof: {
    image: '/s2/raster/lp-website-empower-vision-services.png',
    alt: 'productPage.staticWebsite.testimonial.altText',
    testimonial: {
      quote: 'productPage.staticWebsite.testimonial.quote',
      source: 'productPage.staticWebsite.testimonial.source',
      author: 'productPage.staticWebsite.testimonial.author'
    }
  },
  faqs: {
    title: 'productPage.staticWebsite.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.staticWebsite.frequentlyAskedQuestions.faq1',
        answer: 'productPage.staticWebsite.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.staticWebsite.frequentlyAskedQuestions.faq2',
        answer: 'productPage.staticWebsite.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.staticWebsite.frequentlyAskedQuestions.faq3',
        answer: 'productPage.staticWebsite.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.staticWebsite.frequentlyAskedQuestions.faq4',
        answer: 'productPage.staticWebsite.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.staticWebsite.needAssistance.title',
    getInTouch: 'productPage.staticWebsite.needAssistance.getInTouch',
    actions: 'productPage.staticWebsite.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.staticWebsite.buyBox.buttonLabel'
  })
};
